import { useMemo } from 'react';
import { components as defaultComponents } from 'react-select';

import { wrapMenuList } from '../helpers/wrapMenuList';

export const MenuList = wrapMenuList(defaultComponents.MenuList);

export const useComponentsPure = (useMemoParam, components) =>
  useMemoParam(
    () => ({
      MenuList,
      ...components,
    }),
    [components]
  );

export const useComponents = (components) => useComponentsPure(useMemo, components);
